class RevealComponent extends HTMLElement {
  constructor() {
    super();
    this.class = this.getAttribute('data-reveal-hidden-class');
    this.actionTriggers = this.querySelectorAll('*[data-action="click->reveal#toggle"]');
    this.itemTargets = this.querySelectorAll('*[data-reveal-target="item"]');

    this.connect();
  }

  connect(){
    this.actionTriggers.forEach(item => {
      let action = item.getAttribute('data-action').split('#')[1];
      switch(action){
        case 'toggle': item.addEventListener('click', this.toggle.bind(this));
        break;

        case 'show': item.addEventListener('click', this.show.bind(this));
        break;

        case 'hide': item.addEventListener('click', this.hide.bind(this));
        break;
      }
    })
  }

  toggle () {
    this.itemTargets.forEach(item => {
      item.classList.toggle(this.class)
    })
  }

  show () {
    this.itemTargets.forEach(item => {
      item.classList.remove(this.class)
    })
  }

  hide () {
    this.itemTargets.forEach(item => {
      item.classList.add(this.class)
    })
  }

}

customElements.define('reveal-component', RevealComponent);